/*
  Hellomaterials mobile header. Loaded by snippets/hm-mobile-header.liquid.

  Phone widths only (up to 767px):
    - the header search bar becomes an icon next to the menu button
      (layout: menu + search | logo | account + cart)
    - the sticky header hides on scroll down and returns on scroll up

  Works with Hyper's own predictive search. Closing always goes through the
  theme's own close button, which removes body.search-open and unlocks page
  scrolling. Hiding the bar alone would leave the page locked.

  If you switch Hyper's own "Sticky header" setting to "On scroll up", set
  HIDE_ON_SCROLL to false so the two do not both move the header.
*/
(function () {
  'use strict';

  var HIDE_ON_SCROLL = true;
  var SCROLL_THRESHOLD = 6;           // px of movement ignored, stops flicker
  var MOBILE = window.matchMedia('(max-width: 767px)');
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';

  var teardown = null;

  function panelOpen() { return document.body.classList.contains('search-open'); }
  // never hide the header while the menu drawer, or any drawer that locks the page, is open
  function drawerOpen(menu) { return (menu && menu.getAttribute('aria-expanded') === 'true') || getComputedStyle(document.body).overflow === 'hidden'; }

  function init() {
    if (teardown) teardown();

    var hdr    = document.querySelector('.header-section');
    var bar    = hdr && hdr.querySelector('.header__search');
    var menu   = hdr && hdr.querySelector('.menu-drawer-button');
    var input  = bar && bar.querySelector('input[type="search"], .search__input');
    var themeX = bar && bar.querySelector('.header__search-close');
    if (!hdr || !bar || !menu || !input) return;   // header changed: leave the theme as it is

    var btn = hdr.querySelector('.hm-search-btn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hm-search-btn';
      btn.innerHTML = ICON;
      menu.parentNode.insertBefore(btn, menu.nextSibling);
    }
    if (!bar.id) bar.id = 'hm-header-search';
    btn.setAttribute('aria-controls', bar.id);
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Search');

    var open = false;

    function openSearch() {
      open = true;
      hdr.classList.add('hm-search-open');
      hdr.classList.remove('hm-hide');
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', 'Close search');
      input.focus();                     // same tap, so the phone keyboard opens
    }

    function closeSearch(returnFocus) {
      if (!open) return;
      open = false;
      if (panelOpen() && themeX) themeX.click();
      document.body.classList.remove('search-open');
      input.blur();
      hdr.classList.remove('hm-search-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Search');
      if (returnFocus) btn.focus();
    }

    function onBtn() { if (open) closeSearch(false); else openSearch(); }
    function onKey(e) { if (e.key === 'Escape' && open && MOBILE.matches) closeSearch(true); }

    // the theme's own close button or Escape closed the results: collapse the bar too
    var hadPanel = panelOpen();
    var bodyObs = new MutationObserver(function () {
      var now = panelOpen();
      if (hadPanel && !now && open && MOBILE.matches) closeSearch(false);
      hadPanel = now;
    });

    // hide on scroll down, show on scroll up. Plain passive listener: it compares
    // two numbers and toggles a class. Header height is cached, so scrolling never
    // forces a layout calculation.
    var lastY = Math.max(0, window.scrollY);
    var hdrH = hdr.offsetHeight;
    function onScroll() {
      var y = Math.max(0, window.scrollY);
      if (!MOBILE.matches || open || panelOpen() || drawerOpen(menu) || y <= 0) {
        hdr.classList.remove('hm-hide'); lastY = y; return;
      }
      var dy = y - lastY;
      if (Math.abs(dy) < SCROLL_THRESHOLD) return;
      if (dy > 0 && y > hdrH) hdr.classList.add('hm-hide');
      else if (dy < 0) hdr.classList.remove('hm-hide');
      lastY = y;
    }
    function onResize() { hdrH = hdr.offsetHeight; }
    function onMedia() { if (!MOBILE.matches) { closeSearch(false); hdr.classList.remove('hm-hide'); } }

    btn.addEventListener('click', onBtn);
    document.addEventListener('keydown', onKey);
    bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (HIDE_ON_SCROLL) {
      hdr.classList.add('hm-scroll-hide');
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
    }
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', onMedia);
    else MOBILE.addListener(onMedia);

    teardown = function () {
      closeSearch(false);
      btn.removeEventListener('click', onBtn);
      document.removeEventListener('keydown', onKey);
      bodyObs.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if (MOBILE.removeEventListener) MOBILE.removeEventListener('change', onMedia);
      else MOBILE.removeListener(onMedia);
      hdr.classList.remove('hm-hide', 'hm-search-open', 'hm-scroll-hide');
      teardown = null;
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // the theme editor re-renders the header when a setting changes
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.header__search')) init();
  });
})();
